import { useAiCreditWarnings } from './useAiCreditWarnings';
import React, { createContext, useContext, useEffect, useLayoutEffect, useMemo, useSyncExternalStore, lazy, Suspense } from 'react';
import { useAuth } from '../../../components/contexts/AuthContext';
import { useAccess } from '../../access/context/AccessProvider';
import { PERMISSIONS } from '../../access/constants/permissionKeys';
import { useSocket } from '../../../components/contexts/SocketContext';
import { aiChatFeatures } from '../models/aiChatFeatures';
import { registerSessionReset } from '../../../utils/sessionLifecycle';
import { createAiChatStore } from './aiChatStore';
const AiChatPageExit = lazy(() => import('../views/AiChatPageExit'));
const AiChatDock = lazy(() => import('../views/AiChatDock'));
const AiChatContext = createContext(null);
export function AiChatProvider({ children }) {
  const { authState } = useAuth(); const { can } = useAccess(); const { socket } = useSocket();
  const allowed = Boolean(authState?.isAuthenticated && can(PERMISSIONS.AI_ASSISTANT_VIEW));
  const manage = Boolean(authState?.isAuthenticated && can('ai_assistant.manage_configuration'));
  useAiCreditWarnings(socket, manage);
  const identity = `${authState?.id || ""}:${authState?.token || ""}`;
  const store = useMemo(() => identity && allowed ? createAiChatStore({ manage, userId:authState?.id }) : null, [allowed, manage, identity, authState?.id]);
  useLayoutEffect(() => { if (!store) return; store.activate(); const unregister = registerSessionReset(store.dispose); return () => { unregister(); store.dispose(); }; }, [store]);
  useEffect(() => store?.connect(socket), [store, socket]);
  return <AiChatContext.Provider value={store}>{children}{store && <DockSurface store={store} />}</AiChatContext.Provider>;
}
export const useAiChatStore = () => useContext(AiChatContext);
const unavailable = Object.freeze({ chats: [], details: {}, streams: {}, drafts: {}, posting: {}, providers: [], loadingDetails: {} });
const emptySnapshot = () => unavailable, emptySubscribe = () => () => {};
export function useAiChat() {
  const store = useAiChatStore();
  const state = useSyncExternalStore(store?.subscribe || emptySubscribe, store?.getSnapshot || emptySnapshot);
  return { store, state };
}

function DockSurface({ store }) {
  const state=useSyncExternalStore(store.subscribe,store.getSnapshot);
  return <Suspense fallback={null}>{state.dock?.open && <AiChatDock />}{aiChatFeatures.incognitoDelete && state.activeId && <AiChatPageExit />}</Suspense>;
}
